<template>
  <v-row no-gutters>
    <v-col class="navBar border-right">
      <v-sheet :height="height" class="overflow-auto">
        <v-row no-gutters>
          <v-col cols="12">
            <v-row class="px-3 pt-2" no-gutters align="center">
              <v-col><h4 class="font-weight-regular">{{$tools.dateText(filter.daySelected)}}</h4></v-col>
              <v-col cols="auto">
                <v-btn icon @click="setToday()">
                  <v-icon v-if="isToday" color="primary" small>mdi-checkbox-blank-circle</v-icon>
                  <v-icon v-else small>mdi-checkbox-blank-circle-outline</v-icon>
                </v-btn>
              </v-col>
            </v-row>
            <date-picker :daySelected.sync="filter.daySelected" :events.sync="usersSelectedEvents" :usersSelectedEventsColors.sync="usersSelectedEventsColors" cookieName="visitsDay"/>
          </v-col>
        </v-row>

        <div class="mb-4 mx-3">
          <v-row class="rowSmall overflow-x-hidden">
            <v-col cols="12" class="pt-3">
              <v-slider
                  max="100"
                  min="0"
                  dense
                  hide-details
                  v-model="zoomSlide"
              >
                <template v-slot:prepend>
                  <v-sheet width="56">
                    <v-icon>mdi-magnify-plus-outline</v-icon><div class="caption d-inline-block">{{zoomSlide}}%</div>
                  </v-sheet>
                </template>
              </v-slider>
            </v-col>
            <v-col cols="6">
              <v-btn
                  @click="lockNew=!lockNew"
                  :class="lockNew ? 'v-btn--active' : ''"
                  block depressed
              >
                Блок
                <v-icon class="ml-2" small>mdi-lock</v-icon>
              </v-btn>
            </v-col>
            <v-col cols="6">
              <v-btn block depressed color="silver" @click="listView = !listView" v-if="!listView">
                Список <v-icon class="ml-2" small> mdi-view-list-outline</v-icon>
              </v-btn>
              <v-btn block depressed color="silver" @click="listView = !listView" v-if="listView">
                Сетка <v-icon class="ml-2" small> mdi-land-rows-vertical</v-icon>
              </v-btn>
            </v-col>
            <v-col cols="12">
              <v-btn block depressed color="silver" @click="$router.push('/visit/list/')">
                Период <v-icon class="ml-2" small> mdi-view-list-outline</v-icon>
              </v-btn>
            </v-col>
            <v-col v-if="visitCreateVisitPlan||dataFromCaller||visitMove">
              <v-btn block depressed color="primary" @click="clearDataFromCaller();visitMove=null;">
                Отменить <span v-if="visitMove">перенос</span><span v-else>визит</span>
              </v-btn>
            </v-col>
            <v-col v-if="basketItems.length>0">
              <v-btn block depressed color="primary" @click="basketModalOpen=true">
                <v-icon small class="mr-1">mdi-cart</v-icon> Корзина ({{ basketItems.length }})
              </v-btn>
            </v-col>
          </v-row>
        </div>
        <div class="px-3">
          <com-branch-autocomplete-multiple :select.sync="filter.comBranchesSelected" globalState/>
          <spec-autocomplete-multiple :select.sync="filter.specsSelected" globalState/>

          <autocomplete-multiple name="Специалисты" :items="usersSpecs" :select.sync="filter.userSpecSelected" textOverflow>
            <template v-slot:customInfo="{item}">
              <v-row no-gutters class="py-2" style="max-width: 400px;">
                <v-col cols="12" class="subtitle-2">
                  <v-list-item-avatar class="user mr-3" size="32">
                    <img :src="item.imageUrl" alt="" v-if="item.imageUrl">
                  </v-list-item-avatar>
                  {{$tools.userFullName(item)}}
                </v-col>
                <v-col cols="12">
                  <template v-for="(userSpec,index) in item.userSpecs">
                  <div class="caption" :key="'us_'+index">
                    <div>
                      <v-avatar :color="userSpec.comDiv.comBranch.color" size="10" class="mr-1" style="margin-top:-2px"/>
                      {{userSpec.spec.name}} ({{ userSpec.comDiv.comBranch.name }})
                    </div>
                    <template  v-if="!$tools.isEmpty(userSpec.commentAdmin)">
                    <v-icon class="ml-2 mr-1" small>mdi-comment-text-outline</v-icon>
                    {{userSpec.commentAdmin}}
                    </template>
                  </div>
                </template>
                </v-col>
              </v-row>
            </template>
            <template v-slot:selectedInfo="{item}">
              <div class="d-flex align-center">          
                <v-list-item-avatar class="user ml-0 mr-1" size="18">
                  <img :src="item.imageUrl" alt="" v-if="item.imageUrl">
                </v-list-item-avatar>
                {{$tools.userFullName(item,true)}} 
              </div> 
            </template>     
          </autocomplete-multiple>

          <service-select title="Специалисты по услугам" top :selectedServices.sync="filter.userSpecServices"/>
          <v-checkbox v-model="statusActive" label="Только с активным статусом" class="mb-4" dense hide-details="auto" @click="VisitStatusesCheckbox(statusActive)"/>
          <v-autocomplete
              v-model="filter.visitStatusSelected"
              :items="visitStatuses"
              :search-input.sync="visitStatusText"
              label="Статус"
              outlined
              dense
              hide-details="auto"
              multiple
              class="mb-4"
              item-text="name"
              item-value="id"
              :disabled="loadState.isLoading"
          >
            <template v-slot:no-data>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>Не найдено</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
            <template v-slot:item="{item}">
              <v-list-item-title>
                <div class="py-2">
                  <v-avatar :color="item.color" size="12" class="mr-2"/>{{item.name}}
                </div>
              </v-list-item-title>
            </template>
            <template v-slot:selection="{item}">
              <v-chip class="full-width mt-2" small style="width:95%">
                <v-row no-gutters>
                  <v-col cols="auto"><v-avatar :color="item.color" class="circleIcon mr-2"/></v-col>
                  <v-col class="text-overflow">{{item.name}}</v-col>
                  <v-col cols="auto"><v-icon small @click.stop="filter.visitStatusSelected=filter.visitStatusSelected.filter((v)=>v!==item.id)">mdi-close-circle</v-icon></v-col>
                </v-row>
              </v-chip>
            </template>
          </v-autocomplete>
          <tag-autocomplete-multiple :select.sync="filter.tags" entityType="user" :mode.sync="filter.tagsMode" :start.sync="filter.tagStartDate" :end.sync="filter.tagEndDate" class="mb-3"/>

          <span class="caption">Создать визит с интервалом:</span>
          <v-btn-toggle class="mb-3" dense v-model="forcedVisitDuration">
            <v-btn value="5">5м</v-btn>
            <v-btn value="10">10м</v-btn>
            <v-btn value="15">15м</v-btn>
            <v-btn value="30">30м</v-btn>
            <v-btn value="60">60м</v-btn>
          </v-btn-toggle>

          <v-btn class="my-3" small block depressed color="silver" @click="filterReset">
            Очистить фильтр
          </v-btn>
        </div>
      </v-sheet>
    </v-col>
    <v-col ref="calendarSheet" class="calendarSheet" style="padding-right: 56px;">
      <div
          class="calendarScroll"
          :style="{
            height:height+'px',
            maxWidth:maxWidth+'px',
            //right:typeof navMenuRight==='undefined' ? '' : (400-54)+'px'
          }"
      >
        <v-data-table
            v-if="listView"
            :headers="visibleHeaders"
            :items="visits"
            sort-by="begin"
            dense
            :items-per-page="-1"
            :fixed-header="typeof height!=='undefined'"
            :height="height-84"
            ref="visitsList"
            :footer-props="{
                  'disable-items-per-page':true,
                  'disable-pagination':true,
                  'items-per-page-text':''
                }"
        >

          <template v-slot:top>
            <div class="d-flex justify-end">
              <tooltip right>
                <v-btn
                    color="grey"
                    class="mx-2"
                    text
                    :loading="loadState.isLoading"
                    @click="tableSettingsOpen=true"
                > <v-icon small>mdi-cog-outline</v-icon>
                </v-btn>
                <template v-slot:content>
                  Настройки
                </template>
              </tooltip>
            </div>

            <dialog-editor :item.sync="tableSettingsOpen" name="Настройки таблицы" width="800" submitText="Сохранить" @submit="saveTableSettings();tableSettingsOpen=null" content-padding-remove>

              <template v-slot:footerActions>
                <v-btn
                    @click="listViewHeaders = listViewHeadersDefault"
                    color="primary" text
                >
                  Сбросить настройки
                </v-btn>
              </template>

              <v-simple-table class="pa-0" dense>
                <template v-slot:default>
                  <thead>
                  <tr>
                    <th>Название</th>
                    <th>Показать</th>
                    <th>Сортировка</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr
                      v-for="(item, index) in listViewHeaders"
                      :key="'setting'+index"
                      :style="item.isSelected&&{background:'#E8F5E9'}"
                  >
                    <td class="py-1">
                      {{ item.text }}
                    </td>
                    <td class="py-1">
                      <v-checkbox
                          v-model="item.visible"
                          color="primary"
                          hide-details
                          class="pa-0 mt-0"
                      ></v-checkbox>
                    </td>
                    <td class="py-1">
                      <v-btn text @click="moveColumnUp(item.text)" class="px-1"><v-icon small color="green">mdi-arrow-up-thick</v-icon></v-btn>
                      <v-btn text @click="moveColumnDown(item.text)" class="px-1"><v-icon small color="orange">mdi-arrow-down-thick</v-icon></v-btn>
                    </td>
                  </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </dialog-editor>
          </template>

          <template v-slot:item="{item, index}">
            <tr v-if="!!item.user" @click="visitId=item.id;">

              <template v-for="header in listViewHeaders">

                <td v-if="header.value === 'status'&&header.visible" class="text-no-wrap" :key="item.id+header.value+index">
                  <visit-status :status="$tools.findById(visitStatuses, item.status)" :isPaidFull="item.paySummary.isPaidFull" :isSecond="item.isSecond" small/>
                </td>

                <td v-else-if="header.value === 'user.userProfile.medCardNumber'&&header.visible" :key="item.id+header.value+index">
                  {{item.user.userProfile.medCardNumber ? item.user.userProfile.medCardNumber : item.user.id}}
                </td>

                <td v-else-if="header.value === 'user.lastName'&&header.visible" class="text-no-wrap" :key="item.id+header.value+index">
                  <UserFullName :user="item.user"/>
                </td>

                <td v-else-if="header.value === 'user.phone'&&header.visible" class="text-no-wrap" :key="item.id+header.value+index">
                  <call-phone :phone="item.user.phone" />
                </td>

                <td class="text-no-wrap" v-else-if="header.value === 'userSpec.user.lastName'&&header.visible" :key="item.id+header.value+index">
                  <UserFullName :user="item.userSpec.user" type="spec" avatar/>
                </td>

                <td v-else-if="header.value === 'userSpec.spec.name'&&header.visible" class="text-no-wrap" :key="item.id+header.value+index">
                  {{ item.userSpec.spec.name }}
                </td>

                <td v-else-if="header.value === 'comPlace.comRoom.sid'&&header.visible" class="text-no-wrap" :key="item.id+header.value+index">
                  {{ item.comPlace.comRoom.sid }}
                </td>

                <td v-else-if="header.value === 'begin'&&header.visible" class="text-no-wrap" :key="item.id+header.value+index">
                  {{$tools.dateTimeFormat(item.begin, 'DD.MM.YYYY')}} в {{$tools.dateTimeFormat(item.begin, 'HH:mm')}}
                </td>

                <td v-else-if="header.value === 'comment'&&header.visible" class="text-no-wrap" :data-print="item.comment" :key="item.id+header.value+index">
                  <tooltip v-if="!$tools.isEmpty(item.comment)" bottom>
                    {{$tools.truncateText(item.comment,50)}}
                    <template v-slot:content>
                      <vue-markdown>{{item.comment}}</vue-markdown>
                    </template>
                  </tooltip>
                </td>

                <td v-else-if="header.value === 'visitServices[0].name'&&header.visible" class="text-no-wrap" :data-print="item.visitServices.map(i=>i.name).join(' / ')" :key="item.id+header.value+index">
                  <tooltip v-if="item.visitServices" bottom>
                    {{$tools.truncateText(item.visitServices.map(i=>i.name).join(' / '),50)}}
                    <template v-slot:content>
                      <vue-markdown>* {{item.visitServices.map(i=>i.name).join('\n * ')}}</vue-markdown>
                    </template>
                  </tooltip>
                </td>

                <td v-else-if="header.value === 'user.tagLink.tag'&&header.visible" :key="item.id+header.value+index" :data-print="item.user.tagLinks.map(i=>i.tag.name).join(', ')">
                    <tag-show v-if="!$tools.isEmpty(item.user.tagLinks)" :entityId="item.user.id" :tags="item.user.tagLinks" entityType="user" hideTitle lineMode/>
                </td>

              </template>

            </tr>
          </template>
          <template v-slot:footer.prepend>
            <v-btn small text @click="$tools.download($refs.visitsList,downloadListName)">
              <v-icon small class="pr-2">mdi-download</v-icon>Скачать
            </v-btn>
            <v-spacer/>
          </template>
        </v-data-table>
        <v-calendar
            v-show="!listView && cats.length>0"
            ref="calendar"
            v-model="filter.daySelected"
            color="primary"
            type="category"
            category-show-all
            event-overlap-mode="column"
            :categories="cats"
            :events="events"
            :event-color="getEventColor"
            :interval-format="hm"
            :interval-height="(zoomSlide*1.4)+30"
            :interval-minutes="30"
            :interval-count="intervalCountTime"
            :first-time="beginTime"
            category-text="id"
            @mouseenter:time-category="mouseMove"
            @mousemove:time-category="mouseMove"
            @mouseleave:time-category="mouseMove"
            class="visitsCalendar"
        >
          <template v-slot:category="{ category }" >
            <div v-if="typeof category.name==='undefined'"></div>
            <v-menu v-else open-on-hover bottom offset-y :open-delay="500">
              <template v-slot:activator="{ on, attrs }">
                <v-list-item v-bind="attrs" v-on="on">
                  <v-list-item-content v-if="category!=null">
                    <v-list-item-title>
                      <div class="position-absolute ml-1">
                        <v-avatar :color="category.comRoom.comFloor.comBuilding.comBranch.color" size="14"/>
                      </div>
                      <div class="pl-8">{{category.comRoom.comFloor.comBuilding.comBranch.name}}</div>
                      <v-row no-gutters>
                        <v-col cols="auto" class="title pr-2 font-weight-medium text-overflow">
                          {{category.comRoom.sid}}
                        </v-col>
                        <v-col class="subtitle-2 pt-2 font-weight-medium text-overflow">
                          {{ category.comRoom.name}}
                        </v-col>
                      </v-row>
                    </v-list-item-title>
                    <v-list-item-subtitle>
                      <div class="subtitle-2 font-weight-medium text-overflow">{{ category.name}}</div>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </template>
              <v-sheet v-if="category!=null" class="py-2 px-4">
                <div class="caption">Рабочее место</div>
                <div class="subtitle-2">{{category.name}}</div>
                <div class="caption">Номер кабинета / Название кабинета</div>
                <div class="subtitle-2">{{category.comRoom.sid}} / {{category.comRoom.name}}</div>
                <div class="caption">Этаж</div>
                <div class="subtitle-2">{{category.comRoom.comFloor.name}}</div>
                <div class="caption">Адрес строения</div>
                <div class="subtitle-2">{{category.comRoom.comFloor.comBuilding.street}}</div>
                <div class="caption">Филиал</div>
                <div class="subtitle-2">{{category.comRoom.comFloor.comBuilding.comBranch.name}}</div>
              </v-sheet>
            </v-menu>
          </template>
          <template v-slot:event="{ event }">
            <div v-if="event.type==='visitNew'"
                 @click="visitCreate(event)"
                 class="fill-height px-2 overflow-hidden dynamic"
            >
              <div>
                {{ $tools.time(event.start) }}

                {{visitMove ? 'Перенести визит c '+$tools.time(visitMove.begin) :
                  visitCreateVisitPlan ?
                      '('+visitCreateVisitPlan.user.lastName+' '+visitCreateVisitPlan.user.firstName+' '+visitCreateVisitPlan.user.secondName+')' :
                      dataFromCaller?.user ?
                          '('+dataFromCaller.user.lastName+' '+dataFromCaller.user.firstName+' '+dataFromCaller.user.secondName+')' :
                          dataFromCaller?.phone ? 'Новый визит '+dataFromCaller?.phone : 'Новый визит'
                }}
              </div>
            </div>

            <div v-else-if="event.type==='lockNew'"
                 @click="visitMarkState.modalOpen({
                    comPlace:event.comPlace,
                    begin:event.start,
                    end:event.end,
                    comment:null,
                    mark:'blue',
                  });"
                 class="fill-height px-2 overflow-hidden dynamic"
            >
              <div>{{ $tools.time(event.start) }} Блокировка времени</div>
            </div>

            <div v-else-if="typeof event.visit!=='undefined' && !$tools.isEmpty(event.visit.mark)"
                 @click="visitMarkState.modalOpen({
                    id:event.visit.id,
                    comPlace:event.visit.comPlace,
                    begin:event.start,
                    end:event.end,
                    comment:event.visit.comment,
                    mark:event.visit.mark,
                  });"
                 class="faded fill-height"
                 :style="'border-top: solid 2px '+event.visit.mark"
                 :class="{ visitTimeFinish: isFinish(event.end) }"
            >
              <div class="fill-height full-width position-absolute"  :style="'inset:0;opacity: 0.1;background:'+event.visit.mark"></div>

              <div class="px-1 py-1 black--text position-relative">
                <tooltip v-if="!$tools.isEmpty(event.visit.comment)" right>
                  <v-icon x-small :color="event.visit.mark" class="mt-n1">mdi-lock</v-icon>
                  {{$tools.truncateText(event.visit.comment,30)}}
                  <template v-slot:content>
                    <vue-markdown> {{event.visit.comment}}</vue-markdown>
                  </template>
                </tooltip>
              </div>
            </div>

            <div v-else-if="typeof event.userSpecPlan!=='undefined'" class="userSpecPlan">
              <user-spec-plan-calendar-view
                  :event="event"
                  :visitPlans="event.userSpecPlan.visitPlansFromSelectedDateCount"
                  :scrollTop="scrollTop"
                  :zoom="zoomSlide"
                  :state="loadState"
                  @visitPlansForUserSpec="visitPlansForUserSpec"
                  @visitPlansForUserSpecLiveList="visitPlansForUserSpecLiveList"
                  small/>
            </div>

            <div v-else-if="typeof event.visit!=='undefined'"
                 @click="visitId=event.visit.id;"
                 @contextmenu.prevent=""
                 @mousedown.right.prevent="loadState.isSuccess ? startDrag(event) : null"
                 @mouseup.right.stop="loadState.isSuccess ? cancelDrag(event) : null"
                 class="fill-height overflow-hidden position-relative"
            >
              <visit-calendar-view :event="event" :statuses="visitStatuses"/>
            </div>
          </template>
          <template v-slot:day-body="{ date, week }">
            <div
                v-if="isToday"
                class="v-current-time"
                :class="{ first: date === week[0].date }"
                :style="{ top: nowY }"
            ></div>
          </template>
        </v-calendar>
      </div>
      <div v-if="loadState.isLoading" class="position-absolute full-width" style="z-index:10">
        <v-progress-linear indeterminate color="primary" height="8"/>
      </div>
      <div>
        <v-card class="position-absolute" style="right:0;top:0;z-index:100" :height="height" :width="typeof navMenuRight==='undefined' ? 56 : 400" tile>
          <v-row no-gutters>
            <v-col cols="auto" class="border-right">
              <v-sheet width="56" :height="height">
                <v-list-item-group v-model="navMenuRight" color="primary">
                  <v-list-item class="py-2">
                    <v-icon :color="navMenuRight===0 ? 'primary' : ''">mdi-calendar-question</v-icon>
                  </v-list-item>
                  <v-list-item class="py-2">
                    <v-icon :color="navMenuRight===1 ? 'primary' : ''">mdi-calendar-today</v-icon>
                  </v-list-item>
                  <v-list-item class="py-2">
                    <span class="counter">{{ visitsMove.length }}</span>
                    <v-icon :color="navMenuRight===2 ? 'primary' : ''">mdi-calendar-account</v-icon>
                  </v-list-item>
                </v-list-item-group>
              </v-sheet>
            </v-col>
            <v-col style="position: relative;">
              <visit-plans
                  v-if="navMenuRight===0 || navMenuRight===1"
                  ref="visitPlans"
                  :height="height"
                  :usersSpecs="usersSpecs"
                  :filterUserSpec.sync="visitPlansFilterUserSpec"
                  :filterSpec.sync="visitPlansFilterSpec"
                  :filterComBranch="filter.comBranchesSelected"
                  :daySelected="filter.daySelected"
                  :liveList="navMenuRight===1"
                  :dataFromCaller.sync="dataFromCaller"
                  @cancel="navMenuRight=undefined;visitPlansFilterUserSpec=[]"
                  @visitCreate="visitCreateByVisitPlan"
                  @clearDataFromCaller="clearDataFromCaller"
              />

              <visit-move 
              v-if="navMenuRight===2" 
              :visits="visitsMove" 
              :height="height"
              @visit-open="(v)=>visitId=v" 
              @move="(v)=>{visitId=null;visitMove=v}"
              @cancel="navMenuRight=undefined;visitPlansFilterUserSpec=[]"
              />
            </v-col>
          </v-row>
        </v-card>
      </div>
      
      <alert-view  v-if="loadState.isSuccess && cats.length===0" icon="mdi-information-outline" text="Не найдено" />

      <visit
          :visitId.sync="visitId"
          :usersSpecs="usersSpecs"
          :servicesId="filter.userSpecServices?.map(v=>v.id)"
          @visitCreate="visitCreateByVisitPlan"
          @move="(v)=>{visitId=null;visitMove=v}"
      />
      <visit-mark :state="visitMarkState"  @cancel="visitMarkState.modalClose();load()"/>
      <client-search-or-create
        :state="visitCreateState"
        :dataFromCaller.sync="dataFromCaller"
        @cancel="visitCreateState.modalClose();clearDataFromCaller();"
        @userSelected="visitCreateByUser"
        @userCreate="visitCreateByNewUser"
        @visitMove="visitMoveAction"
        visitMode
      />    


      <dialog-editor :item.sync="basketModalOpen" name="Корзина" width="800" submitText="Очистить корзину" @submit="$store.dispatch('clearBasket');basketModalOpen=null" content-padding-remove>
        <v-simple-table class="pa-0"  dense>
          <template v-slot:default>
            <thead>
            <tr>
              <th>ID</th>
              <th>Название</th>
              <th>Код</th>
              <th>Длительность</th>
              <th class="text-no-wrap">Срок исполнения</th>
              <th class="text-no-wrap">План (с/по)</th>
              <th>Цена</th>
            </tr>
            </thead>
            <tbody>
            <tr
                v-for="(item, index) in basketItems"
                :key="'selected'+index"
            >
              <td>{{item.id}}</td>
              <td class="text-wrap" >
                {{item.name}}
                <div v-if="!$tools.isEmpty(item.comment)">
                  <v-icon small>mdi-comment-text-outline</v-icon>
                  <div class="caption mt-n5 ml-5">{{item.comment}}</div>
                </div>
              </td>
              <td>
                <service-code-view :code="item.code"/>
              </td>
              <td>
                {{typeof item.duration==='undefined' ? '' : item.duration+' мин.'}}
              </td>
              <td>
                {{typeof item.resultDuration==='undefined' ? '' : item.resultDuration+' д.'}}
              </td>
              <td>
                <template v-if="typeof item.startDay !=='undefined'">
                  {{item.startDay==null ? '-' : item.startDay+'д.'}} {{item.endDay==null ? '' : ' / ' + item.endDay+'д.'}}
                </template>
              </td>
              <td class="text-no-wrap text-right">
                <span v-if="typeof item.priceTotal!=='undefined'">{{$tools.price(item.priceTotal)}}</span>
              </td>
            </tr>
            <tr>
              <td colspan="6"><span class="subtitle-2">Итого:</span></td>
              <td class="text-no-wrap text-right"><span class="subtitle-2">{{$tools.price(basketTotalPrice, '-')}}</span></td>
            </tr>
            </tbody>
          </template>
        </v-simple-table>
      </dialog-editor>
    </v-col>
  </v-row>
</template>


<script>
import moment from "moment";
import State from "@/plugins/state";
import axios from "axios";
import Api from "@/Api";
import VisitCalendarView from "@/views/Visit/VisitCalendarView";
import VisitMark from "@/views/Visit/VisitMark";
import Visit from "@/views/Visit/Visit";
import UserSpecPlanCalendarView from "@/views/UserSpec/UserSpecPlanCalendarView";
import AlertView from "@/components/AlertView";
import VisitPlans from "@/views/Visit/VisitPlans";
import VisitMove from "@/views/Visit/VisitMove";
import ServiceSelect from "@/views/Service/components/ServiceSelect";
import DatePicker from "@/components/DatePicker";
import CallPhone from "@/components/CallPhone.vue";
import VisitStatus from "@/components/VisitStatus";
import AutocompleteMultiple from "@/componentsV2/base/AutocompleteMultiple.vue";
import ComBranchAutocompleteMultiple from "@/componentsV2/custom/ComBranchAutocompleteMultiple.vue";
import SpecAutocompleteMultiple from "@/componentsV2/custom/SpecAutocompleteMultiple.vue";
import Tooltip from "@/componentsV2/base/Tooltip.vue";
import DialogEditor from "@/componentsV2/base/DialogEditor.vue";
import ServiceCodeView from "@/views/Service/ServiceCodeView";
import UserFullName from "@/componentsV2/custom/UserFullName.vue"
import ClientSearchOrCreate from "@/views/User/Client/ClientSearchOrCreate";
import TagAutocompleteMultiple from "../../componentsV2/custom/TagAutocompleteMultiple.vue";
import TagShow from "@/views/Tag/components/TagShow.vue";

import {
  Entity_UserSpecPlan,
  Entity_UserSpec, 
  Entity_User, 
  Entity_Spec, 
  Entity_ComPlace, 
  Entity_ComDiv,
  Entity_ComRoom, 
  Entity_ComFloor, 
  Entity_ComBuilding, 
  Entity_ComBranch,
  Entity_Visit,
  Entity_UserProfile,
  Entity_Referral,
  Entity_ProductCalendar,
  Entity_UserService, 
  Entity_Service,
  Entity_VisitService,
  Entity_Tag,
  Entity_TagLink
} from "../../../EntityStoreCacheService";

export default {
  components: {
    ComBranchAutocompleteMultiple,
    AutocompleteMultiple,
    SpecAutocompleteMultiple,
    VisitPlans, 
    VisitMove, 
    AlertView, 
    UserSpecPlanCalendarView, 
    Visit, 
    VisitCalendarView, 
    VisitMark, 
    ServiceSelect, 
    DatePicker, 
    CallPhone,
    VisitStatus, 
    Tooltip,
    DialogEditor,
    ServiceCodeView,
    UserFullName,
    ClientSearchOrCreate,
    TagAutocompleteMultiple,
    TagShow
  },
  data: () => ({
    zoomSlide:50,
    height: 600,
    maxWidth: 1000,
    nowY:0,

    loadState: new State(),

    filterStorageKey: 'visitsFilter?v4',
    filter: {},
    baseFilter: {
      daySelected: moment(new Date()).format('YYYY-MM-DD'),
      comBranchesSelected:[],
      specsSelected:[],
      userSpecSelected:[],
      userSpecServices:[],
      visitStatusSelected:[],
      tags: [],
      tagsMode: 'simple',
      tagStartDate: null,
      tagEndDate: null,
    },

    usersSpecs:[],
    usersAllows:[],
    //usersText:null,

    visitStatuses:Api.model.Visit.statuses,
    visitStatusText:null,
    statusActive: true,
    
    visitId:null,
    visitMove:null,

    userSpecPlans:[],

    comRooms:[],
    // comPlaces:[],
    comPlacesShows:[],
    cats:[],
    events:[],
    beginTime:'00:00',
    endTime:'00:00',
    intervalCountTime:0,
    eventDrag:null,

    lockNew:false,
    visitMarkState: new State(),
    visitCreateState: new State(),
    visitCreateVisitPlan:null,

    navMenuRight:undefined,

    // visitPlansState: new State(),
    // visitPlans:[],
    visitPlansFilterUserSpec:[],
    visitPlansFilterSpec:[],

    refreshTimer:null,
    timeLine:null,

    dataFromCaller: null,
    //точки на календаре
    usersSelectedEvents: [],
    usersSelectedEventsColors: {},

    //вид списком
    listView: false,
    tableSettingsOpen: false,
    listViewHeaders:[
      { text: 'Статус', value: 'status', sortable: true, visible: true},
      { text: 'Номер карты', value: 'user.userProfile.medCardNumber', sortable: true, visible: true},
      { text: 'Кто', value: 'user.lastName', sortable: true, visible: true},
      { text: 'Телефон', value: 'user.phone', sortable: true, visible: true},
      { text: 'К кому', value: 'userSpec.user.lastName', sortable: true, visible: true},
      { text: 'Специальность', value:'userSpec.spec.name', sortable: true, visible: true},
      { text: 'Кабинет', value: 'comPlace.comRoom.sid', sortable: true, visible: true},
      { text: 'Дата и время', value: 'begin', sortable: true, visible: true},
      { text: 'Комментарий', value: 'comment', sortable: true, visible: true},
      { text: 'Услуги', value: 'visitServices[0].name', sortable: true, visible: true},
      { text: 'Теги', value: 'user.tagLink.tag', sortable: true, visible: true},
    ],
    listViewHeadersDefault: [],
    visits:[],
    visitsMove:[],

    scrollTop: 0,
    forcedVisitDuration:false,
    //basket
    basketModalOpen: false,
    addServicesToVisit: false
  }),
  beforeMount(){
    this.zoomSlide = typeof localStorage.zoomCalendar==='undefined' ? 50 : localStorage.zoomCalendar;
  },
  mounted(){
    this.filter = this.$tools.storageGet(this.filterStorageKey, this.$tools.copy(this.baseFilter))

    if (!this.$tools.storageGet(this.filterStorageKey))
      this.VisitStatusesCheckbox(this.statusActive);

    // настройки таблицы списка визитов
    this.listViewHeadersDefault = this.$tools.copy(this.listViewHeaders);//сохраняем базовые настройки
    this.listViewHeaders = this.$tools.storageGet('visitListViewTableSettings?v2', this.$tools.copy(this.listViewHeadersDefault))
    
    if (this.$refs.calendar!==undefined)  
      this.$refs.calendar.$el.addEventListener("scroll", this.handleScroll);

    this.usersSpecsLoad();
    this.load();
    this.resize();
    window.addEventListener('resize', ()=>{
      this.resize();
    }, true);

    this.updateNow();
    this.timeLine = setInterval(() =>this.updateNow(), 5 * 1000)

    this.refreshTimer = setInterval(()=>{
      this.$tools.pageVisibleCallback(()=> {
        this.load(true);
      }, ()=>{
        this.$store.commit('alertWarning', 'Данные могли устареть. Обновите страницу или подождите 60 сек.');
      })
    }, 60000);
  },
  beforeDestroy(){
    clearInterval(this.refreshTimer);
    clearInterval(this.timeLine);
  },
  computed:{
    isToday(){
      return this.filter.daySelected===moment(new Date()).format('YYYY-MM-DD');
    },
    basketItems() {
      return this.$store.getters.basketItems;
    },
    basketTotalPrice() {
      return this.$store.getters.basketTotalPrice;
    },
    downloadListName(){
      const usersSelected = this.filter.userSpecSelected;
      const usr = usersSelected.length>0 ? this.$tools.userFullName(usersSelected[0],true) : null;

      const postFix = usersSelected.length===1 ? ` (${usr})` :  usersSelected.length>1 ? ` (${usr} и др.)` : ''
      return 'Список визитов'+ postFix;
    },
    visibleHeaders() {
      return this.listViewHeaders.filter(h => h.visible);
    }
  },
  watch:{
    filter: {
      deep: true,
      handler () {
        this.$tools.storageSet(this.filterStorageKey, this.filter);

        this.load();
        this.getUserSelectedEvents();
      },
    },
    'filter.specsSelected'(){
      this.$tools.debounce(()=>{
        this.usersSpecsLoad();
      }, 250, 'usersLoad')
    },
    'filter.comBranchesSelected'(){
      this.$tools.debounce(()=>{
        this.usersSpecsLoad();
      }, 250, 'usersLoad')
    },
    zoomSlide(){
      localStorage.zoomCalendar = this.zoomSlide;
      this.updateNow();
    },
    '$route': {
      handler: function() {   
        if (Object.keys(this.$router.currentRoute.query).length !== 0) {
          const visitPlanId = this.$router.currentRoute.query.visitPlanId;
          const phone = this.$router.currentRoute.query.phone
          const type = this.$router.currentRoute.query.type;
          const visitServices = this.$router.currentRoute.query.visitServices?.split(',')||[];

          this.clearDataFromCaller()

          // add phone
          if (phone) {
              this.dataFromCaller = {
                ...(this.dataFromCaller || {}), 
                phone:phone                       
              }
          }

          // add user
          if (typeof this.$router.currentRoute.query.userId !== 'undefined') {
              new Entity_User()
              .selects([Entity_User.id].join('.'))
              .selects([Entity_User.firstName].join('.'))
              .selects([Entity_User.lastName].join('.'))
              .selects([Entity_User.secondName].join('.'))
              .filterAnd([Entity_User.entity, Entity_User.id].join('.')+' =?',parseInt(this.$router.currentRoute.query.userId))
              .page(1).onPage(1)
              .order(Entity_User.lastName,true)
              .addStateCallback((v)=> this.loadState.setRequestBuilderState(v))
              .request((data)=>{
                let user = data.count>0 ? data.items[0] : null;

                if (type !== undefined&&type === 'visitPlan'){// если это создание визита из листа ожидания (из карты клиента)
                  this.visitCreateVisitPlan = {user:user,id:visitPlanId}
                } else {// dataFromCaller
                  this.dataFromCaller = {
                    ...(this.dataFromCaller || {}), 
                    user:user                            
                  }
                  if (visitServices.length>0) //visitServices 
                    this.dataFromCaller = {
                      ...(this.dataFromCaller || {}), 
                      visitServices:visitServices                         
                    }
                }
              }, (e)=>{
                console.error(e.response.data.message);
              });
          }
          
          // visitPlan запись из карточки клиента из листа ожижания
          // waitingList запись из виджета в лист ожидания
          // liveList запись из виджета в лист живой очереди

          // add type
          if (this.$router.currentRoute.query.type !== undefined
            &&this.$router.currentRoute.query.type !== 'visitPlan'){                
            if(this.$router.currentRoute.query.type === 'waitingList') {
                this.navMenuRight = 0 
                this.dataFromCaller = {
                  ...(this.dataFromCaller || {}), 
                  type:'waitingList'                        
                }
            } else if (this.$router.currentRoute.query.type === 'liveList'){
               this.navMenuRight = 1 
                this.dataFromCaller = {
                  ...(this.dataFromCaller || {}), 
                  type:'liveList'                        
                }
            }
          }
       
          // visit move
          if (typeof this.$router.currentRoute.query.visitMove !== 'undefined') {
            Api.service.visit.visit(this.$router.currentRoute.query.visitMove, v=> {
              this.visitMove = v;
              }, error => {
                this.loadState.stateError();
                console.log(error)
            });
          }

          this.$router.replace({ path: this.$route.path, query: {} });
        }
      },
      immediate: true
    },
    'filter.visitStatusSelected'(){
      if (this.filter.visitStatusSelected.some(value => this.$inactiveStatuses.includes(value))) {
        this.statusActive = false;
      }
    },
    visitId(){
      if(this.visitId===null)
        this.load();
    },
    loadState: {
      deep: true,
      handler() {
        if (this.loadState.isSuccess){
          this.handleScroll()
        }
      },
    },
    navMenuRight(){
      this.resize()
    }
  },
  methods: {
    handleScroll() {
      if(this.$refs.calendar!==undefined)
        this.scrollTop = this.$refs.calendar.$el.scrollTop;
    },
    usersSpecsLoad(){
      //нужно для листа ожидания (специалисты) и фильтра по специалистам
      let rb = new Entity_User()
      .selects([Entity_User.id].join('.'))
      .selects([Entity_User.firstName].join('.'))
      .selects([Entity_User.lastName].join('.'))
      .selects([Entity_User.secondName].join('.'))
      .selects([Entity_User.imageUrl].join('.'))
      .selects([Entity_User.type].join('.'))

      // .selects([Entity_UserSpecPlan.userSpec,Entity_UserSpec.user, Entity_User.userSpecs, Entity_UserSpec.id ].join('.'))
      // .selects([Entity_UserSpecPlan.userSpec,Entity_UserSpec.user, Entity_User.userSpecs, Entity_UserSpec.commentAdmin].join('.'))
      
      .selects([Entity_User.userSpecs, Entity_UserSpec.id ].join('.'))
      .selects([Entity_User.userSpecs, Entity_UserSpec.spec, Entity_Spec.id ].join('.'))
      .selects([Entity_User.userSpecs, Entity_UserSpec.spec, Entity_Spec.name ].join('.'))
      .selects([Entity_User.userSpecs, Entity_UserSpec.spec, Entity_Spec.color ].join('.'))

      .selects([Entity_User.userSpecs, Entity_UserSpec.commentAdmin ].join('.'))
      .selects([Entity_User.userSpecs, Entity_UserSpec.comDiv, Entity_ComDiv.name ].join('.'))
      .selects([Entity_User.userSpecs, Entity_UserSpec.comDiv, Entity_ComDiv.comBranch,Entity_ComBranch.id ].join('.'))
      .selects([Entity_User.userSpecs, Entity_UserSpec.comDiv, Entity_ComDiv.comBranch,Entity_ComBranch.name ].join('.'))
      .selects([Entity_User.userSpecs, Entity_UserSpec.comDiv, Entity_ComDiv.comBranch,Entity_ComBranch.color ].join('.'))
      .filterAnd([Entity_User.entity, Entity_User.type].join('.')+' =?','spec')

      if(this.filter.specsSelected.length>0)
        rb.filterAnd([Entity_User.entity, Entity_User.userSpecs, Entity_UserSpec.spec, Entity_Spec.id].join('.')+' in (?)',this.filter.specsSelected.map(i=>i.id));

      if(this.filter.comBranchesSelected.length>0)
        rb.filterAnd([Entity_User.entity, Entity_User.userSpecs, Entity_UserSpec.comDiv, Entity_ComDiv.comBranch, Entity_ComBranch.id].join('.')+' in (?)',this.filter.comBranchesSelected.map(i=>i.id));


      rb.page(null) 
      .order(Entity_User.lastName,true)
      // .addStateCallback((v)=> this.loadState.setRequestBuilderState(v))
      .request((data)=>{
        this.usersSpecs = data.items
      }, (e)=>{
        console.error(e.response.data.message);
      });
    },
    load(){
      this.$tools.debounce(()=>{
        this.updateNow();
        this.loadState.stateLoading();
        const loadingData = [];
        const productCalendar = new Promise((resolve, reject) => {
          //productCalendar
          let rb = new Entity_ProductCalendar()
            .collect(Entity_ProductCalendar.collect_workPlan)

            //filter by date
            rb.filterAnd([Entity_ProductCalendar.entity, Entity_ProductCalendar.date].join('.')+'>=?',moment(this.filter.daySelected).format('YYYY-MM-DD 00:00:00'));
            rb.filterAnd([Entity_ProductCalendar.entity, Entity_ProductCalendar.date].join('.')+'<=?',moment(this.filter.daySelected).format('YYYY-MM-DD 23:59:59'));

            //filter by comBranchs
            if(this.filter.comBranchesSelected.length>0)
              rb.filterAnd([Entity_ProductCalendar.entity, Entity_ProductCalendar.comBranch, Entity_ComBranch.id].join('.')+' in (?)',this.filter.comBranchesSelected.map(i=>i.id));
            //rb.page(1).onPage(1);
            rb.request((data)=>{
                if (data.collect.workPlan.items.length>0) {
                  this.beginTime = data.collect.workPlan.items[0].begin;
                  this.endTime = data.collect.workPlan.items[0].end;
                } else {
                  this.beginTime = '00:00';
                  this.endTime = '23:59';
                }
                this.intervalCountTime = Math.round(moment.duration(moment(this.endTime, 'HH:mm').diff(moment(this.beginTime, 'HH:mm'))).asHours()*2);

                resolve()
              }, (e)=>{
                reject();
                console.error(e.response.data.message);
              })
        });
        loadingData.push(productCalendar);

        const userSpecPlans = new Promise((resolve, reject) => {
          let rb = new Entity_UserSpecPlan()
          .selects(Entity_UserSpecPlan.id)
          .selects(Entity_UserSpecPlan.begin)
          .selects(Entity_UserSpecPlan.end)
          .selects(Entity_UserSpecPlan.type)
          .selects(Entity_UserSpecPlan.gridMinutes)
          .selects(Entity_UserSpecPlan.status)

          //User
          .selects([Entity_UserSpecPlan.userSpec,Entity_UserSpec.user,Entity_User.id].join('.'))
          .selects([Entity_UserSpecPlan.userSpec,Entity_UserSpec.user, Entity_User.firstName].join('.'))
          .selects([Entity_UserSpecPlan.userSpec,Entity_UserSpec.user, Entity_User.lastName].join('.'))
          .selects([Entity_UserSpecPlan.userSpec,Entity_UserSpec.user, Entity_User.secondName].join('.'))
          .selects([Entity_UserSpecPlan.userSpec,Entity_UserSpec.user, Entity_User.imageUrl].join('.'))
          .selects([Entity_UserSpecPlan.userSpec,Entity_UserSpec.user, Entity_User.userProfile, Entity_UserProfile.comment].join('.'))


          //spec comBranches
          //.selects([Entity_UserSpecPlan.userSpec, Entity_UserSpec.comDiv, Entity_ComDiv.comBranch,Entity_ComBranch.name ].join('.'))
          .selects([Entity_UserSpecPlan.userSpec, Entity_UserSpec.comDiv, Entity_ComDiv.comBranch,Entity_ComBranch.color ].join('.'))

          //UserSpec (spec for userSpecPlans)
          .selects([Entity_UserSpecPlan.userSpec,Entity_UserSpec.id].join('.'))
          .selects([Entity_UserSpecPlan.userSpec,Entity_UserSpec.commentAdmin].join('.'))
          //.selects([Entity_UserSpecPlan.userSpec,Entity_UserSpec.user,Entity_User.id].join('.'))
          .selects([Entity_UserSpecPlan.userSpec,Entity_UserSpec.spec, Entity_Spec.id].join('.'))
          .selects([Entity_UserSpecPlan.userSpec,Entity_UserSpec.spec, Entity_Spec.name].join('.'))
          .selects([Entity_UserSpecPlan.userSpec,Entity_UserSpec.spec, Entity_Spec.color].join('.'))

          //comRoom
          .selects([Entity_UserSpecPlan.comPlace, Entity_ComPlace.comRoom, Entity_ComRoom.id].join('.'))
          .selects([Entity_UserSpecPlan.comPlace, Entity_ComPlace.comRoom, Entity_ComRoom.name].join('.'))
          .selects([Entity_UserSpecPlan.comPlace, Entity_ComPlace.comRoom, Entity_ComRoom.sid].join('.'))
          .selects([Entity_UserSpecPlan.comPlace, Entity_ComPlace.comRoom, Entity_ComRoom.comPlaces, Entity_ComPlace.id].join('.'))
          .selects([Entity_UserSpecPlan.comPlace, Entity_ComPlace.comRoom, Entity_ComRoom.comPlaces, Entity_ComPlace.name].join('.'))

          //comPlace
          .selects([Entity_UserSpecPlan.comPlace,Entity_ComPlace.id].join('.'))
          .selects([Entity_UserSpecPlan.comPlace,Entity_ComPlace.name].join('.'))

          //comBranch
          .selects([Entity_UserSpecPlan.comPlace,Entity_ComPlace.comRoom,Entity_ComRoom.comFloor,Entity_ComFloor.comBuilding, Entity_ComBuilding.comBranch,Entity_ComBranch.id].join('.'))
          .selects([Entity_UserSpecPlan.comPlace,Entity_ComPlace.comRoom,Entity_ComRoom.comFloor,Entity_ComFloor.comBuilding, Entity_ComBuilding.comBranch,Entity_ComBranch.name].join('.'))
          .selects([Entity_UserSpecPlan.comPlace,Entity_ComPlace.comRoom,Entity_ComRoom.comFloor,Entity_ComFloor.comBuilding, Entity_ComBuilding.comBranch,Entity_ComBranch.color].join('.'))
          .selects([Entity_UserSpecPlan.comPlace,Entity_ComPlace.comRoom,Entity_ComRoom.comFloor,Entity_ComFloor.comBuilding, Entity_ComBuilding.comBranch,Entity_ComBranch. workPlan].join('.'))


          //visitPlans
          rb.virtual(Entity_UserSpecPlan.virtual_visitPlansFromSelectedDateCount, moment(this.filter.daySelected).format('YYYY-MM-DD 00:00:00'))

          // filter by date
          rb.filterAnd([Entity_UserSpecPlan.entity, Entity_UserSpecPlan.begin].join('.')+'>=?',moment(this.filter.daySelected).format('YYYY-MM-DD 00:00:00'));
          rb.filterAnd([Entity_UserSpecPlan.entity, Entity_UserSpecPlan.begin].join('.')+'<=?',moment(this.filter.daySelected).format('YYYY-MM-DD 23:59:59'));

          // filter by type
          rb.filterAnd([Entity_UserSpecPlan.entity, Entity_UserSpecPlan.type].join('.')+' in (?)',['workVisit','workVisitReserve']);
          rb.filterAnd([Entity_UserSpecPlan.entity, Entity_UserSpecPlan.status].join('.')+'=?','active');

          //filter by comBranchs
          if(this.filter.comBranchesSelected.length>0)
            rb.filterAnd([Entity_UserSpecPlan.entity, Entity_UserSpecPlan.comPlace, Entity_ComPlace.comRoom, Entity_ComRoom.comFloor, Entity_ComFloor.comBuilding, Entity_ComBuilding.comBranch,Entity_ComBranch.id].join('.')+' in (?)',this.filter.comBranchesSelected.map(i=>i.id));

          // filter by users
          if (this.filter.userSpecSelected.length>0)
            rb.filterAnd([Entity_UserSpecPlan.entity, Entity_UserSpecPlan.userSpec, Entity_UserSpec.user,Entity_User.id].join('.')+' in (?)',this.filter.userSpecSelected.map(i=>i.id));

          // filter by specs
          if(this.filter.specsSelected.length>0)
            rb.filterAnd([Entity_UserSpecPlan.entity, Entity_UserSpecPlan.userSpec, Entity_UserSpec.spec, Entity_Spec.id].join('.')+' in (?)',this.filter.specsSelected.map(i=>i.id));

          // filter.userSpecServices
          if (this.filter.userSpecServices.length>0)
            rb.filterAnd([Entity_UserSpecPlan.entity, Entity_UserSpecPlan.userSpec, Entity_UserSpec.user, Entity_User.userServices, Entity_UserService.service, Entity_Service.id].join('.')+' in (?)',this.filter.userSpecServices.map(i=>i.id));

          //заменить на поле для сортировки
          rb.order([Entity_UserSpecPlan.comPlace, Entity_ComPlace.comRoom, Entity_ComRoom.comFloor, Entity_ComFloor.comBuilding, Entity_ComBuilding.comBranch, Entity_ComBranch.id].join('.'),true);
          rb.order([Entity_UserSpecPlan.comPlace, Entity_ComPlace.comRoom, Entity_ComRoom.id].join('.'),true);

          //rb.page(null);
          rb.request((dataUserSpecPlans)=>{
            this.userSpecPlans = dataUserSpecPlans.items;
            resolve()
          }, (e)=>{
            reject()
            console.error(e.response.data.message);
            this.loadState.stateError(e)
          })
        });
        loadingData.push(userSpecPlans);

        const visits = new Promise((resolve, reject) => {
          let rb = new Entity_Visit()
              .selects(Entity_Visit.id)
              .selects(Entity_Visit.begin)
              .selects(Entity_Visit.comment)
              .selects(Entity_Visit.created)
              .selects(Entity_Visit.end)
              .selects(Entity_Visit.isSecond)
              .selects(Entity_Visit.mark)
              .selects(Entity_Visit.status)


              //user
              .selects([Entity_Visit.user, Entity_User.id].join('.'))
              .selects([Entity_Visit.user, Entity_User.firstName].join('.'))
              .selects([Entity_Visit.user, Entity_User.lastName].join('.'))
              .selects([Entity_Visit.user, Entity_User.secondName].join('.'))
              .selects([Entity_Visit.user, Entity_User.phone].join('.'))
              .selects([Entity_Visit.user, Entity_User.userProfile, Entity_UserProfile.medCardNumber].join('.'))
              // .selects([Entity_Visit.user, Entity_User.userProfile, Entity_UserProfile.gender].join('.'))
              .selects([Entity_Visit.user, Entity_User.userProfile, Entity_UserProfile.isSelfEdit].join('.'))
              .selects([Entity_Visit.user, Entity_User.userProfile, Entity_UserProfile.birth].join('.'))
              .selects([Entity_Visit.user, Entity_User.userProfile, Entity_UserProfile.resAddrStreet].join('.'))
              .selects([Entity_Visit.user, Entity_User.userProfile, Entity_UserProfile.comment].join('.'))
              
              // tags
              .selects([Entity_Visit.user, Entity_User.tagLinks, Entity_TagLink.id].join('.'))
              .selects([Entity_Visit.user, Entity_User.tagLinks, Entity_TagLink.status].join('.'))
              .selects([Entity_Visit.user, Entity_User.tagLinks, Entity_TagLink.tag, Entity_Tag.name].join('.'))
              .selects([Entity_Visit.user, Entity_User.tagLinks, Entity_TagLink.tag, Entity_Tag.color].join('.'))


              //userSpec
              .selects([Entity_Visit.userSpec, Entity_UserSpec.user, Entity_User.id].join('.'))
              .selects([Entity_Visit.userSpec, Entity_UserSpec.user, Entity_User.firstName].join('.'))
              .selects([Entity_Visit.userSpec, Entity_UserSpec.user, Entity_User.lastName].join('.'))
              .selects([Entity_Visit.userSpec, Entity_UserSpec.user, Entity_User.secondName].join('.'))
              .selects([Entity_Visit.userSpec, Entity_UserSpec.spec, Entity_Spec.name].join('.'))
              .selects([Entity_Visit.userSpec, Entity_UserSpec.user, Entity_User.imageUrl].join('.'))

              //referral
              .selects([Entity_Visit.referral, Entity_Referral.id].join('.'))
              .selects([Entity_Visit.referral, Entity_Referral.comment].join('.'))
              .selects([Entity_Visit.referral, Entity_Referral.phone].join('.'))
              .selects([Entity_Visit.referral, Entity_Referral.name].join('.'))
              .selects([Entity_Visit.referral, Entity_Referral.status].join('.'))

              //user
              .selects([Entity_Visit.referral, Entity_Referral.user, Entity_User.id].join('.'))
              .selects([Entity_Visit.referral, Entity_Referral.user, Entity_User.firstName].join('.'))
              .selects([Entity_Visit.referral, Entity_Referral.user, Entity_User.lastName].join('.'))
              .selects([Entity_Visit.referral, Entity_Referral.user, Entity_User.secondName].join('.'))
              .selects([Entity_Visit.referral, Entity_Referral.user, Entity_User.phone].join('.'))

              //comPlace
              .selects([Entity_Visit.comPlace, Entity_ComPlace.id].join('.'))
              .selects([Entity_Visit.comPlace, Entity_ComPlace.comRoom, Entity_ComRoom.sid].join('.'))

              //comBranch
              .selects([Entity_Visit.comPlace, Entity_ComPlace.comRoom, Entity_ComRoom.comFloor, Entity_ComFloor.comBuilding, Entity_ComBuilding.comBranch, Entity_ComBranch.id].join('.'))
              .selects([Entity_Visit.comPlace, Entity_ComPlace.comRoom, Entity_ComRoom.comFloor, Entity_ComFloor.comBuilding, Entity_ComBuilding.comBranch, Entity_ComBranch.name].join('.'))
              .selects([Entity_Visit.comPlace, Entity_ComPlace.comRoom, Entity_ComRoom.comFloor, Entity_ComFloor.comBuilding, Entity_ComBuilding.comBranch, Entity_ComBranch.color].join('.'))

              //visitServices
              .selects([Entity_Visit.visitServices, Entity_VisitService.id].join('.'))
              .selects([Entity_Visit.visitServices, Entity_VisitService.name].join('.'))

              //virtual
              .virtual(Entity_Visit.virtual_paySummary);

          // filter by date
          rb.filterAnd([Entity_Visit.entity, Entity_Visit.begin].join('.')+'>=?',moment(this.filter.daySelected).format('YYYY-MM-DD 00:00:00'));
          rb.filterAnd([Entity_Visit.entity, Entity_Visit.begin].join('.')+'<=?',moment(this.filter.daySelected).format('YYYY-MM-DD 23:59:59'));

          // filter by combranch
          if(this.filter.comBranchesSelected.length>0)
            rb.filterAnd([Entity_Visit.entity, Entity_Visit.comPlace, Entity_ComPlace.comRoom, Entity_ComRoom.comFloor, Entity_ComFloor.comBuilding, Entity_ComBuilding.comBranch, Entity_ComBranch.id].join('.')+' in (?)',this.filter.comBranchesSelected.map(i=>i.id));

          // filter by users
          if (this.filter.userSpecSelected.length>0)
            rb.filterAnd([Entity_Visit.entity, Entity_Visit.userSpec, Entity_UserSpec.user,Entity_User.id].join('.')+' in (?) OR '+
                [Entity_Visit.entity,Entity_Visit.mark].join('.')+' is not null',this.filter.userSpecSelected.map(i=>i.id));
          

          // filter by specs
          if(this.filter.specsSelected.length>0)
            rb.filterAnd([Entity_Visit.entity, Entity_Visit.userSpec, Entity_UserSpec.spec, Entity_Spec.id].join('.')+' in (?) OR '+
                [Entity_Visit.entity,Entity_Visit.mark].join('.')+' is not null',this.filter.specsSelected.map(i=>i.id));

          // filter by status
          if(this.filter.visitStatusSelected.length>0)
            rb.filterAnd([Entity_Visit.entity, Entity_Visit.status].join('.')+' in (?) OR '+
                [Entity_Visit.entity,Entity_Visit.mark].join('.')+' is not null',this.filter.visitStatusSelected);

                
          if (!this.$tools.isEmpty(this.filter.tags)) {
            rb.filterAnd([Entity_Visit.entity, Entity_Visit.user, Entity_User.tagLinks, Entity_TagLink.status].join('.')+'=?','active');
            let start = this.filter.tagStartDate ?  moment(this.filter.tagStartDate, 'DD.MM.YYYY').format('YYYY-MM-DD') : null;
            let end = this.filter.tagEndDate ?  moment(this.filter.tagEndDate, 'DD.MM.YYYY').format('YYYY-MM-DD') : null;
            rb.filterAdd(Entity_Visit.filterAdd_userTags, [this.filter.tags.map(v => v.id), this.filter.tagsMode, start, end].join('|'))
          }
          

          rb.order(Entity_Visit.begin, true);

          //rb.page(null);
          rb.request((dataVisits)=>{
            this.visits = dataVisits.items;
            resolve();
          }, (e)=>{
            reject();
            console.error(e.response.data.message);
            this.loadState.stateError(e)
          })
        });
        loadingData.push(visits);

        Promise.all(loadingData).then(() => {
          this.comPlacesShows = [...new Map(this.userSpecPlans.map(i=>i.comPlace).map(item => [item.id, item])).values()];

          //cats
          this.cats = [];
          this.resize();
          this.comPlacesShows.forEach((v)=>{
            this.cats.push({
              id:v.id+'_userSpecPlan',
              comPlace:v
            });
            this.cats.push(v);
          });

          this.events = [];
          let dayBegin = moment(this.filter.daySelected + ' ' + this.beginTime + ':00', 'YYYY-MM-DD HH:mm:ss').toDate();
          let dayEnd = moment(this.filter.daySelected + ' ' + this.endTime + ':00', 'YYYY-MM-DD HH:mm:ss').toDate();

          this.userSpecPlans.forEach(userSpecPlan=>{
            this.events.push({
                userSpecPlan: userSpecPlan,
                start: moment(userSpecPlan.begin, 'YYYY-MM-DD HH:mm:ss').toDate(),
                end: moment(userSpecPlan.end, 'YYYY-MM-DD HH:mm:ss').toDate(),
                color: 'rgb(245 245 245)',
                timed: true,
                category: userSpecPlan.comPlace.id+'_userSpecPlan'
            });
          })

          let userSpecPlanEventCats = [];
          this.events.forEach((event)=>{
            userSpecPlanEventCats[event.userSpecPlan.comPlace.id] = [];
          });
          this.events.forEach((event)=>{
            userSpecPlanEventCats[event.userSpecPlan.comPlace.id].push(event);
          });

          userSpecPlanEventCats.forEach((events, comPlaceId)=>{
            //first
            let intervals = [];
            events.forEach((event)=>{
              intervals.push({
                begin: moment(event.userSpecPlan.begin, 'YYYY-MM-DD HH:mm:ss'),
                end: moment(event.userSpecPlan.end, 'YYYY-MM-DD HH:mm:ss')
              });
            });

            intervals = intervals.sort((a, b)=>{
              if (a.begin>b.begin) return 1;
              if (a.begin<b.begin) return -1;
              return 0;
            });

            let noPlans = [];
            //begin
            intervals.forEach((interval)=>{
              if(noPlans.length===0){
                noPlans[0] = {
                  begin:dayBegin,
                  end:interval.begin.toDate()
                };
              } else{
                if(noPlans[0].begin>interval.begin)
                  noPlans[0] = {
                    begin:dayBegin,
                    end:interval.begin.toDate()
                  };
              }
            });

            //between
            intervals.forEach((interval, index)=>{
              if(index>0){
                noPlans.push({
                  begin:intervals[index-1].end.toDate(),
                  end:interval.begin.toDate()
                });
              }
            });

            //end
            noPlans.push({
              begin:intervals[intervals.length-1].end.toDate(),
              end:dayEnd
            });

            noPlans = noPlans.filter(noPlan=>noPlan.begin.getTime()!==noPlan.end.getTime());

            noPlans.forEach((noPlan)=>{
              this.events.push({
                start: noPlan.begin,
                end: noPlan.end,
                color: 'rgb(245 245 245)',
                timed: true,
                category: comPlaceId,
                type: 'noPlan'
              });
              this.events.push({
                start: noPlan.begin,
                end: noPlan.end,
                color: 'rgb(245 245 245)',
                timed: true,
                category: comPlaceId + '_userSpecPlan',
                type: 'noPlan'
              });
            });
          });

          //visits
          if (this.filter.userSpecSelected.length>0) { // исключаем "блокировки" не попадающие в диапазон при включенном фильтре по специалистам
            const plans = this.userSpecPlans.map(uSp => ({
              start: moment(uSp.begin, 'YYYY-MM-DD HH:mm:ss'),
              end: moment(uSp.end, 'YYYY-MM-DD HH:mm:ss'),
              comPlaceId: uSp.comPlace.id
            }));

            const filteredVisits = this.visits.filter(v => {
              const visitTime = moment(v.begin, 'YYYY-MM-DD HH:mm:ss');

              return plans.some(p =>
                visitTime.isBetween(p.start, p.end, null, '[]')&&p.comPlaceId===v.comPlace.id
              );
            });

            this.visits = filteredVisits;
          }

          this.visits.forEach((visit)=>{
            this.events.push({
              visit: visit,
              start: moment(visit.begin, 'YYYY-MM-DD HH:mm:ss').toDate(),
              end: moment(visit.end, 'YYYY-MM-DD HH:mm:ss').toDate(),
              color: 'rgb(245 245 245)',
              timed: true,
              category: visit.comPlace.id
            });          
          });


          //visits for move
          this.visitsMove = this.visits.filter(v=>v.status==='move');

          if(!this.filter.visitStatusSelected.includes('move'))
            this.events = this.events.filter(e=>typeof e.visit!=='undefined'&&e.visit.status!=='move'||typeof e.visit==='undefined');

      

          this.loadState.stateSuccess();
          this.resize();
          this.updateNow();

        })
        .catch((error) => {
          console.error('Error:', error);
        });

      }, 250, 'visitsLoad')
    },
    //drag
    startDrag(event){
      this.eventDrag = event;
    },
    mouseMove({ category, date, time }){   
      this.events = this.events.filter(v=>v.type!=='lockNew' && v.type!=='visitNew');
      
      if(this.eventDrag!==null) {
        let t = moment(date + ' ' + time, 'YYYY-MM-DD HH:mm');

        let diff = moment(this.eventDrag.end).diff(this.eventDrag.start, 'minutes');

        let beginTime = t.minute(t.minute() - (t.minute() % 5));
        let endTime = t.clone().add(diff, 'minutes');

        let userSpecPlans = this.userSpecPlans.filter((v) => v.comPlace.id === category.id);
        let userSpecPlan = null;
        userSpecPlans.forEach((v) => {
          if (
              category.id === v.comPlace.id &&
              beginTime >= moment(v.begin, 'YYYY-MM-DD HH:mm:ss') &&
              endTime <= moment(v.end, 'YYYY-MM-DD HH:mm:ss')
          )
            userSpecPlan = v;
        });

        if (userSpecPlan !== null) {
          this.eventDrag.category = category.id;
          this.eventDrag.start = beginTime.toDate();
          this.eventDrag.end = endTime.toDate();
        }
      } else {

  
        if(typeof category.id==='number'){
          let beginTime = moment(date+' '+time, 'YYYY-MM-DD HH:mm:ss');

          let userSpecPlans = this.userSpecPlans.filter((v)=>v.comPlace.id===category.id);
          let userSpecPlan = null;
          userSpecPlans.forEach((v)=>{
            if(
                category.id===v.comPlace.id &&
                beginTime>=moment(v.begin, 'YYYY-MM-DD HH:mm:ss') &&
                beginTime<moment(v.end, 'YYYY-MM-DD HH:mm:ss')
            )
              userSpecPlan = v;
          });
          


          if(userSpecPlan!==null){

            beginTime = beginTime.minute(beginTime.minute() - (beginTime.minute() % 5));
            let endTime = !this.forcedVisitDuration ? beginTime.clone().add(userSpecPlan.gridMinutes, 'minutes').toDate() : beginTime.clone().add(this.forcedVisitDuration, 'minutes').toDate();
            beginTime = beginTime.toDate();

            //next event start        
            let nextEventStart = false;
            for (const v of this.events) {
              if(moment(v.start).isBetween(moment(beginTime),moment(endTime))&&v.category == category.id) {
                nextEventStart = moment(v.start, 'YYYY-MM-DD HH:mm:ss');
                break;
              }
            }

            //if it's another event
            let timeOccupied = false;
            for (const v of this.events) {
              if(moment(beginTime).isBetween(moment(v.start).subtract(1, 'minutes'),moment(v.end))&&v.category == category.id) {
                timeOccupied = true;
                break;
              }
            } 

            if(!timeOccupied) {            
              if(moment(beginTime).unix()>moment().hour(0).minutes(0).seconds(0).unix()||this.lockNew){
                let userSpecPlanEnd = moment(userSpecPlan.end, 'YYYY-MM-DD HH:mm:ss');
                let diff = moment(userSpecPlanEnd).diff(moment(endTime),'m');

                this.events.push({
                  start: beginTime,
                  end: diff<0 ? userSpecPlanEnd.toDate() : nextEventStart ? nextEventStart.toDate() : endTime,
                  color: diff<0||nextEventStart ? 'error' : 'primary',
                  timed: true,
                  category: category.id,
                  comPlace: category,
                  type:this.lockNew ? 'lockNew' :'visitNew',
                  gridMinutes: userSpecPlan.gridMinutes
                });
              }
            }
          }
        }
      }
    },
    cancelDrag(event){
      this.$confirm('Вы уверены, что хотите переместить визит?', '', 
      ()=>{this.visitUpdateTime(event);this.eventDrag = null;},
      ()=>{this.load();this.eventDrag = null;})
    },

    //calendar tools
    getEventColor(event) {
      return event.color
    },
    hm(interval){
      return interval.time;
    },
    visitPlansForUserSpec(v){
      this.navMenuRight=0;
      this.visitPlansFilterUserSpec = [];
      this.visitPlansFilterSpec = [];
      this.visitPlansFilterUserSpec.push(v);
      this.visitPlansFilterSpec.push(v.spec);
    },
    visitPlansForUserSpecLiveList(v){
      this.navMenuRight=1;
      this.visitPlansFilterUserSpec = [];
      this.visitPlansFilterSpec = [];
      this.visitPlansFilterUserSpec.push(v);
      this.visitPlansFilterSpec.push(v.spec);
    },
    visitCreateByVisitPlan(v){
      this.visitCreateVisitPlan = v;
    },

    //tools
    resize(){
      this.height = window.innerHeight-64;
      this.maxWidth = this.$refs.calendarSheet.clientWidth;
      if(this.$tools.isDefined(this.navMenuRight))
        this.maxWidth -= 400;
      else
        this.maxWidth -= 54;
    },
    updateNow(){
      this.$nextTick(()=>{
        this.$refs.calendar.updateTimes()
        if(this.cats.length>0 && this.loadState.isSuccess){
          this.nowY = this.$refs.calendar.timeToY(this.$refs.calendar.times.now) + 'px'
        } else {
          this.nowY = '-100px';
        }
      })
    },

    setToday() {
      this.filter.daySelected = moment(new Date()).format('YYYY-MM-DD');
      this.load();
    },
    isFinish(t) {
      if (moment(t).diff(moment(), 'minutes')<0) {
        return true
      }  
    },
    clearDataFromCaller() {
      // this.dataFromCaller = {
      //   phone: null,
      //   user: null,
      //   type: null,
      //   visitServices: []
      // }
      this.dataFromCaller = null
      this.visitCreateVisitPlan = null
    },
    getUserSelectedEvents() {
      this.usersSelectedEvents = [];
      this.usersSelectedEventsColors = {};
 
    if ([
        this.filter.specsSelected.length > 0,
        this.filter.userSpecSelected.length > 0,
        this.filter.userSpecServices.length > 0
      ].some(Boolean)) {
        this.loadState.stateLoading();

        let rb = new Entity_UserSpecPlan()
        .selects(Entity_UserSpecPlan.id)
        .selects(Entity_UserSpecPlan.begin)
        .selects(Entity_UserSpecPlan.type)
        .selects(Entity_UserSpecPlan.status)
        .selects([Entity_UserSpecPlan.userSpec,Entity_UserSpec.user,Entity_User.id].join('.'))
        .selects([Entity_UserSpecPlan.userSpec,Entity_UserSpec.spec, Entity_Spec.id].join('.'))
        .selects([Entity_UserSpecPlan.comPlace,Entity_ComPlace.comRoom,Entity_ComRoom.comFloor,Entity_ComFloor.comBuilding, Entity_ComBuilding.comBranch,Entity_ComBranch.id].join('.'))
        .selects([Entity_UserSpecPlan.comPlace,Entity_ComPlace.comRoom,Entity_ComRoom.comFloor,Entity_ComFloor.comBuilding, Entity_ComBuilding.comBranch,Entity_ComBranch.color].join('.'))
     
        rb.filterAnd([Entity_UserSpecPlan.entity, Entity_UserSpecPlan.begin].join('.')+'>=?',moment(this.filter.daySelected).subtract(62, 'days').format('YYYY-MM-DD 00:00:00'));
        rb.filterAnd([Entity_UserSpecPlan.entity, Entity_UserSpecPlan.type].join('.')+' in (?)',['workVisit','workVisitReserve']);
        rb.filterAnd([Entity_UserSpecPlan.entity, Entity_UserSpecPlan.status].join('.')+'=?','active');

        //filter by comBranchs
        if(this.filter.comBranchesSelected.length>0) 
          rb.filterAnd([Entity_UserSpecPlan.entity, Entity_UserSpecPlan.comPlace, Entity_ComPlace.comRoom, Entity_ComRoom.comFloor, Entity_ComFloor.comBuilding, Entity_ComBuilding.comBranch,Entity_ComBranch.id].join('.')+' in (?)',this.filter.comBranchesSelected.map(i=>i.id));
        
        // filter by users
        if (this.filter.userSpecSelected.length>0)
          rb.filterAnd([Entity_UserSpecPlan.entity, Entity_UserSpecPlan.userSpec, Entity_UserSpec.user,Entity_User.id].join('.')+' in (?)',this.filter.userSpecSelected.map(i=>i.id));

        // filter by specs
        if(this.filter.specsSelected.length>0)
          rb.filterAnd([Entity_UserSpecPlan.entity, Entity_UserSpecPlan.userSpec, Entity_UserSpec.spec, Entity_Spec.id].join('.')+' in (?)',this.filter.specsSelected.map(i=>i.id));

        // filter.userSpecServices
        if (this.filter.userSpecServices.length>0)
          rb.filterAnd([Entity_UserSpecPlan.entity, Entity_UserSpecPlan.userSpec, Entity_UserSpec.user, Entity_User.userServices, Entity_UserService.service, Entity_Service.id].join('.')+' in (?)',this.filter.userSpecServices.map(i=>i.id));

        rb.page(1).onPage(1000);

        rb.request((data)=>{         
          if (data.count>0) {
            data.items.forEach(uSP=>{
              this.usersSelectedEvents.push(this.$tools.dateTimeFormat(uSP.begin, 'YYYY-MM-DD'));

              let key = this.$tools.dateTimeFormat(uSP.begin, 'YYYY-MM-DD');
              let color = uSP.comPlace.comRoom.comFloor.comBuilding.comBranch.color;
              if (typeof this.usersSelectedEventsColors[key] === 'undefined') {
                this.usersSelectedEventsColors[key] = [];
              }
              if (!this.usersSelectedEventsColors[key].includes(color)&&this.usersSelectedEventsColors[key].length<3) {
                this.usersSelectedEventsColors[key].push(color);
              }
            });
          }
          this.loadState.stateSuccess();
        }, (e)=>{
          console.error(e.response.data.message);
          this.loadState.stateError(e)
        })
      }
     
    },
    VisitStatusesCheckbox(v){
      let allStatuses = this.$activeStatuses.concat(this.$inactiveStatuses);
      this.filter.visitStatusSelected = v ? this.$activeStatuses : allStatuses;
    },
    moveColumnUp(selectedColumn) {
      const index = this.listViewHeaders.findIndex(h => h.text === selectedColumn);
      if (index <= 0) return; // Если элемент первый или не найден - выходим

      // функционал выделения строки с которой взаимодействуем
      this.listViewHeaders.forEach(header => {
        header.isSelected = false;
      });
      this.listViewHeaders[index].isSelected = true;
      
      const newHeaders = [...this.listViewHeaders];
      [newHeaders[index - 1], newHeaders[index]] = [newHeaders[index], newHeaders[index - 1]];
      this.listViewHeaders = newHeaders;
    },
    moveColumnDown(selectedColumn) {
      const index = this.listViewHeaders.findIndex(h => h.text === selectedColumn);
      if (index === -1 || index >= this.listViewHeaders.length - 1) return; // Если элемент последний или не найден

      // функционал выделения строки с которой взаимодействуем
      this.listViewHeaders.forEach(header => {
        header.isSelected = false;
      });
      this.listViewHeaders[index].isSelected = true;
      
      const newHeaders = [...this.listViewHeaders];
      [newHeaders[index], newHeaders[index + 1]] = [newHeaders[index + 1], newHeaders[index]];
      this.listViewHeaders = newHeaders;
    },
    saveTableSettings() {
        this.listViewHeaders.forEach(header => { delete header.isSelected; }); // очищаем от isSelected
        localStorage.setItem('visitListViewTableSettings', JSON.stringify(this.listViewHeaders));
    },
    visitCreateModalOpen(event){
      this.visitCreateState.modalOpen({
          comPlace:event.comPlace,
          begin:event.start,
          end:event.end,
          visitCreateVisitPlan:this.$tools.copy(this.visitCreateVisitPlan),
          visitMove:this.$tools.copy(this.visitMove)
      });
      this.visitCreateVisitPlan=null;
      this.visitMove=null;
    },
    visitCreate(event){
      // Если установлен visitMove (после ошибки 409), создаем визит с новым временем
      if (this.visitMove && !this.visitMove.id) {
        const visitMove = this.visitMove;
        let data = {
          status:'pre',
          begin: moment(event.start).format('YYYY-MM-DD HH:mm:ss'),
          end: moment(event.end).format('YYYY-MM-DD HH:mm:ss'),
          comPlace: event.comPlace.id,
          userId: visitMove.user.id,
          visitPlanId: visitMove.visitPlanId || null,
        }

        if (visitMove.serviceIds && visitMove.serviceIds.length > 0) {
          data.serviceIds = visitMove.serviceIds;
        }
        
        axios.post(Api.host+'/visit/', data)
          .then((r)=> {
            if (visitMove.visitServices && visitMove.visitServices.length > 0) {
              Api.service.visit.visitServiceAdd(r.data.id, visitMove.visitServices, ()=> {
                localStorage.setItem('visitServicesFromMedplan', JSON.stringify(visitMove.visitServices));
                this.visitCreated(r.data.id)
              },(e)=> {
                console.error(e);
              });
            } else {
              this.visitCreated(r.data.id)
            }

            if (visitMove.visitPlanId)
              localStorage.setItem('visitFromVisitPlan', visitMove.visitPlanId);

            setTimeout(()=>{
              if (this.basketItems.length>0){
                this.$confirm('В корзине есть услуги','Очистить?',()=>this.$store.dispatch('clearBasket'));
              }
            },1000)
          })
          .catch((e) =>{
            console.error(e.response.data.message);
            if(e.response.status===409){
              // Время все еще занято - обновляем время в visitMove
              this.visitMove.begin = moment(event.start).format('YYYY-MM-DD HH:mm:ss');
              this.visitMove.end = moment(event.end).format('YYYY-MM-DD HH:mm:ss');
              this.visitMove.comPlace = event.comPlace;
            } else {
              this.visitCreated(null)
            }
          });
        return;
      }
      
      if (this.basketItems.length>0){
        this.$confirm('В корзине есть услуги','Добавить их к визиту?',()=>{this.addServicesToVisit=true;this.visitCreateModalOpen(event);},()=>{this.addServicesToVisit=false;this.visitCreateModalOpen(event);});
      } else {
        this.visitCreateModalOpen(event);
      }
    },
    visitCreateByUser(user, visitPlanId=null, visitServices=[]){
      let data = {
        status:'pre',
        begin:  moment(this.visitCreateState.modalData.begin).format('YYYY-MM-DD HH:mm:ss'),
        end:  moment(this.visitCreateState.modalData.end).format('YYYY-MM-DD HH:mm:ss'),
        comPlace: this.visitCreateState.modalData.comPlace.id,
        userId:user.id,
        visitPlanId:visitPlanId,
      }

      //Добавляем услуги в визит
      if (this.basketItems.length>0&&this.addServicesToVisit) {
        console.log(this.basketItems.map(s=>s.id))
        data.serviceIds = this.basketItems.map(s=>s.id);
      }
      
      axios.post(Api.host+'/visit/', data)
        .then((r)=> {
          this.visitCreateState.stateSuccess();  

          if (visitServices.length>0) {
            Api.service.visit.visitServiceAdd(r.data.id, visitServices, ()=> {
              localStorage.setItem('visitServicesFromMedplan', JSON.stringify(visitServices));// reload medPlan
              this.visitCreated(r.data.id)
            },(e)=> {
              console.error(e);
            });
          }  else {
            this.visitCreated(r.data.id)
          }

          if (visitPlanId)
            localStorage.setItem('visitFromVisitPlan', visitPlanId);


          setTimeout(()=>{
            if (this.basketItems.length>0){
              this.$confirm('В корзине есть услуги','Очистить?',()=>this.$store.dispatch('clearBasket'));
            }
          },1000)
        
        })
        .catch((e) =>{
          console.error(e.response.data.message);
          if(e.response.status===409){
            // Время занято - включаем механизм переноса визита
            this.visitMove = {
              id: null,
              user: user,
              begin: moment(this.visitCreateState.modalData.begin).format('YYYY-MM-DD HH:mm:ss'),
              end: moment(this.visitCreateState.modalData.end).format('YYYY-MM-DD HH:mm:ss'),
              comPlace: this.visitCreateState.modalData.comPlace,
              visitPlanId: visitPlanId,
              visitServices: visitServices,
              serviceIds: this.basketItems.length>0&&this.addServicesToVisit ? this.basketItems.map(s=>s.id) : undefined
            };
            this.visitCreateState.modalClose();
          } else {
            this.visitCreated(null)
          }
        });         
    },
    visitCreateByNewUser(userData){           
      let data = {
        status:'pre',
        begin:  moment(this.visitCreateState.modalData.begin).format('YYYY-MM-DD HH:mm:ss'),
        end:  moment(this.visitCreateState.modalData.end).format('YYYY-MM-DD HH:mm:ss'),
        comPlace: this.visitCreateState.modalData.comPlace.id,
      }

      data = { ...data, ...userData };

      //Добавляем услуги в визит
      if (this.basketItems.length>0&&this.addServicesToVisit) {
        data.serviceIds = this.basketItems.map(s=>s.id);
      }

      axios.post(Api.host+'/visit/', data)
      .then((r)=> {
        this.visitCreateState.stateSuccess();

        this.visitCreated(r.data.id)

        setTimeout(()=>{
          if (this.basketItems.length>0){
            this.$confirm('В корзине есть услуги','Очистить?',()=>this.$store.dispatch('clearBasket'));
          }
        },1000)


      })
      .catch((e)=>{
        console.error(e.response.data.message);
        this.visitCreated(null)
      });
    },
    visitMoveAction(visitMove, visitMoveDuration=false){
      const begin = moment(this.visitCreateState.modalData.begin).format('YYYY-MM-DD HH:mm:ss');
      let end  = moment(this.visitCreateState.modalData.end).format('YYYY-MM-DD HH:mm:ss');
      const comPlace = this.visitCreateState.modalData.comPlace.id;


      if (visitMoveDuration) { //перенос по длительности исходного визита
        let diff = moment(visitMove.end).diff(moment(visitMove.begin), 'minutes');
        end = moment(begin,'YYYY-MM-DD HH:mm:ss').add(diff, 'minutes').format('YYYY-MM-DD HH:mm:ss');
      }

      axios.put(Api.host+'/visit/'+visitMove.id+'/', {
        begin: begin,
        end: end,
        comPlace:comPlace
      })
      .then((r)=> {
        this.visitCreateState.stateSuccess();
        this.visitCreated(r.data.id);
      })
      .catch((e) =>{
        console.error(e.response.data.message);
        this.visitCreated(null)
      });
    },

    visitCreated(visitId){
      this.visitCreateState.modalClose();
      this.forcedVisitDuration = false;
      
      // Очищаем visitMove после успешного создания визита
      if (this.visitMove && !this.visitMove.id) {
        this.visitMove = null;
      }

      if(visitId!==null)
        this.visitId = visitId;
      this.load();
      if(this.navMenuRight===0 || this.navMenuRight===1)
        this.$refs.visitPlans.load();

      this.clearDataFromCaller();
    },
    visitUpdateTime(event){
      this.loadState.stateLoading();
      axios.put(Api.host+'/visit/'+event.visit.id+'/', {
        begin:moment(event.start).format('YYYY-MM-DD HH:mm:00'),
        end:moment(event.end).format('YYYY-MM-DD HH:mm:00'),
        comPlace: event.category
      })
      .then(() =>{
        this.load();
      })
      .catch(e =>{
        Api.responseError(e)
        this.load();
      });
    },
    filterReset() {
      this.filter = this.$tools.copy(this.baseFilter)
      this.VisitStatusesCheckbox(this.statusActive);
    },
  }   
}
</script>


<style type="scss">
  .v-calendar-daily__body {
    padding-bottom: 30px;
  }
  .counter {
    position: absolute;
    top: 4px;
    right: 4px;
    font-size: 12px;
    background: #1976d2;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #ffffff;
    z-index: 9;
  }
</style>